const { styled } = require("@mui/material");
import { Modal, Card, Stack } from "@mui/material";
import { typographyClasses } from "@mui/material/Typography";
import { cardActionsClasses } from "@mui/material/CardActions";
import { cardContentClasses } from "@mui/material/CardContent";
import { buttonClasses } from "@mui/material/Button";

export const MoreBookingsModal = styled(Modal)({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
});

export const MoreBookingsCard = styled(Card)(({ theme }) => ({
  outline: "none",
  width: "400px",
  [`& .${typographyClasses.subtitle1}`]: {
    marginBottom: 8,
    color: theme.palette.primary.main,
  },
  [`& .${cardContentClasses.root}`]: {
    padding: 0,
  },
  [`& .${cardActionsClasses.root}`]: {
    padding: 0,
    [`.${buttonClasses.root}:last-child`]: {
      color: theme.palette.common.black,
    },
  },
}));

export const MoreBookingsStack = styled(Stack)({
  padding: 32,
});
